import { render } from "./subBut.vue?vue&type=template&id=20129780"
import script from "./subBut.vue?vue&type=script&lang=js"
export * from "./subBut.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__